import { Divider, Text } from '@lawpilots/design-system'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

import { useViewport } from '@/hooks'
import { LearnerContentMaxWidth } from './LearnerPage'

// A titled cluster on a learner card screen: the label, a rule that runs on to the right edge,
// then the content. Shared so My certificates' year sections and My courses' Enrolled and
// Completed sections keep the same rhythm.

// Capped with the card grid so the rule ends where the last column does.
const SectionStyles = { display: 'flex', flexDirection: 'column', gap: 2, maxWidth: LearnerContentMaxWidth }

const HeadingStyles = { display: 'flex', alignItems: 'center' }

const RuleStyles = { flex: 1, minWidth: 0 }

type LearnerSectionProps = {
  label: string
  children: ReactNode
}

export const LearnerSection = ({ label, children }: LearnerSectionProps): JSX.Element => {
  const isCompact = useViewport() === 'mobile'

  return (
    <Box sx={SectionStyles}>
      <Box sx={{ ...HeadingStyles, gap: isCompact ? 1 : 3 }}>
        <Text variant={isCompact ? 'body-reading' : 'section-label'} color="secondary" as="h2">
          {label}
        </Text>
        <Box sx={RuleStyles}>
          <Divider emphasis="default" paddingY="xs" />
        </Box>
      </Box>
      {children}
    </Box>
  )
}
